import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

// Disable scrolling on mobile browsers
// window.addEventListener("scroll", preventMotion, false);
// window.addEventListener("touchmove", preventMotion, false);

// function preventMotion(event)
// {
//     event.preventDefault();
//     event.stopPropagation();
// }


var div = document.getElementById('root')
// if(div.requestFullscreen) {
//     div.requestFullscreen();
// } else if (div.webkitRequestFullscreen) {
//     div.webkitRequestFullScreen();
// }


ReactDOM.render(<App />, div);



// WEBPACK FOOTER //
// ./src/index.js